var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"theme-loading-overlay"},[_c('div',{staticClass:"theme-loading-content"},[_c('div',{staticClass:"theme-loading-spinner"}),_c('div',{staticClass:"theme-loading-text"},[_vm._v(_vm._s(_vm.loadingText))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }